
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref040"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref040"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("62Vkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $466f66254aa75085$export$2e2bcd8739ae039);

var $hPtJY = parcelRequire("hPtJY");
function $466f66254aa75085$var$_extends() {
    $466f66254aa75085$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $466f66254aa75085$var$_extends.apply(this, arguments);
}
function $466f66254aa75085$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $466f66254aa75085$var$_setPrototypeOf(subClass, superClass);
}
function $466f66254aa75085$var$_getPrototypeOf(o) {
    $466f66254aa75085$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $466f66254aa75085$var$_getPrototypeOf(o);
}
function $466f66254aa75085$var$_setPrototypeOf(o, p) {
    $466f66254aa75085$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $466f66254aa75085$var$_setPrototypeOf(o, p);
}
function $466f66254aa75085$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $466f66254aa75085$var$_construct(Parent, args, Class) {
    if ($466f66254aa75085$var$_isNativeReflectConstruct()) $466f66254aa75085$var$_construct = Reflect.construct.bind();
    else $466f66254aa75085$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $466f66254aa75085$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $466f66254aa75085$var$_construct.apply(null, arguments);
}
function $466f66254aa75085$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $466f66254aa75085$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $466f66254aa75085$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$466f66254aa75085$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $466f66254aa75085$var$_construct(Class, arguments, $466f66254aa75085$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $466f66254aa75085$var$_setPrototypeOf(Wrapper, Class);
    };
    return $466f66254aa75085$var$_wrapNativeSuper(Class);
}
/* eslint no-console:0 */ var $466f66254aa75085$var$formatRegExp = /%[sdj%]/g;
var $466f66254aa75085$var$warning = function warning() {}; // don't print warning message when in production env or node runtime
typeof $hPtJY !== "undefined" && $hPtJY.env;
function $466f66254aa75085$var$convertFieldsError(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $466f66254aa75085$var$format(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === "function") return template.apply(null, args);
    if (typeof template === "string") {
        var str = template.replace($466f66254aa75085$var$formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $466f66254aa75085$var$isNativeStringType(type) {
    return type === "string" || type === "url" || type === "hex" || type === "email" || type === "date" || type === "pattern";
}
function $466f66254aa75085$var$isEmptyValue(value, type) {
    if (value === undefined || value === null) return true;
    if (type === "array" && Array.isArray(value) && !value.length) return true;
    if ($466f66254aa75085$var$isNativeStringType(type) && typeof value === "string" && !value) return true;
    return false;
}
function $466f66254aa75085$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $466f66254aa75085$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $466f66254aa75085$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, objArr[k] || []);
    });
    return ret;
}
var $466f66254aa75085$var$AsyncValidationError = /*#__PURE__*/ function(_Error) {
    $466f66254aa75085$var$_inheritsLoose(AsyncValidationError, _Error);
    function AsyncValidationError(errors, fields) {
        var _this;
        _this = _Error.call(this, "Async Validation Error") || this;
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return AsyncValidationError;
}(/*#__PURE__*/ $466f66254aa75085$var$_wrapNativeSuper(Error));
function $466f66254aa75085$var$asyncMap(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $466f66254aa75085$var$AsyncValidationError(errors, $466f66254aa75085$var$convertFieldsError(errors))) : resolve(source);
            };
            var flattenArr = $466f66254aa75085$var$flattenObjArr(objArr);
            $466f66254aa75085$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending["catch"](function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $466f66254aa75085$var$AsyncValidationError(results, $466f66254aa75085$var$convertFieldsError(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $466f66254aa75085$var$asyncSerialArray(arr, func, next);
            else $466f66254aa75085$var$asyncParallelArray(arr, func, next);
        });
    });
    pending["catch"](function(e) {
        return e;
    });
    return pending;
}
function $466f66254aa75085$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $466f66254aa75085$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $466f66254aa75085$var$complementError(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $466f66254aa75085$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($466f66254aa75085$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === "function" ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $466f66254aa75085$var$deepMerge(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if (typeof value === "object" && typeof target[s] === "object") target[s] = $466f66254aa75085$var$_extends({}, target[s], value);
            else target[s] = value;
        }
    }
    return target;
}
var $466f66254aa75085$var$required$1 = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || $466f66254aa75085$var$isEmptyValue(value, type || rule.type))) errors.push($466f66254aa75085$var$format(options.messages.required, rule.fullField));
};
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $466f66254aa75085$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === "") errors.push($466f66254aa75085$var$format(options.messages.whitespace, rule.fullField));
};
// https://github.com/kevva/url-regex/blob/master/index.js
var $466f66254aa75085$var$urlReg;
var $466f66254aa75085$var$getUrlRegex = function() {
    if ($466f66254aa75085$var$urlReg) return $466f66254aa75085$var$urlReg;
    var word = "[a-fA-F\\d:]";
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
    };
    var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
    var v6seg = "[a-fA-F\\d]{1,4}";
    var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
    var v4exact = new RegExp("^" + v4 + "$");
    var v6exact = new RegExp("^" + v6 + "$");
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", "g");
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), "g");
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), "g");
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = "(?:\\S+(?::\\S*)?@)?";
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = "(?::\\d{2,5})?";
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
    $466f66254aa75085$var$urlReg = new RegExp("(?:^" + regex + "$)", "i");
    return $466f66254aa75085$var$urlReg;
};
/* eslint max-len:0 */ var $466f66254aa75085$var$pattern$2 = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $466f66254aa75085$var$types = {
    integer: function integer(value) {
        return $466f66254aa75085$var$types.number(value) && parseInt(value, 10) === value;
    },
    "float": function float(value) {
        return $466f66254aa75085$var$types.number(value) && !$466f66254aa75085$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === "number";
    },
    object: function object(value) {
        return typeof value === "object" && !$466f66254aa75085$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === "function";
    },
    email: function email(value) {
        return typeof value === "string" && value.length <= 320 && !!value.match($466f66254aa75085$var$pattern$2.email);
    },
    url: function url(value) {
        return typeof value === "string" && value.length <= 2048 && !!value.match($466f66254aa75085$var$getUrlRegex());
    },
    hex: function hex(value) {
        return typeof value === "string" && !!value.match($466f66254aa75085$var$pattern$2.hex);
    }
};
var $466f66254aa75085$var$type$1 = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        $466f66254aa75085$var$required$1(rule, value, source, errors, options);
        return;
    }
    var custom = [
        "integer",
        "float",
        "array",
        "regexp",
        "object",
        "method",
        "email",
        "number",
        "date",
        "url",
        "hex"
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$466f66254aa75085$var$types[ruleType](value)) errors.push($466f66254aa75085$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
         // straight typeof check
    } else if (ruleType && typeof value !== rule.type) errors.push($466f66254aa75085$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $466f66254aa75085$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === "number";
    var min = typeof rule.min === "number";
    var max = typeof rule.max === "number"; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === "number";
    var str = typeof value === "string";
    var arr = Array.isArray(value);
    if (num) key = "number";
    else if (str) key = "string";
    else if (arr) key = "array";
     // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, "_").length;
    if (len) {
        if (val !== rule.len) errors.push($466f66254aa75085$var$format(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push($466f66254aa75085$var$format(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push($466f66254aa75085$var$format(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push($466f66254aa75085$var$format(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $466f66254aa75085$var$ENUM$1 = "enum";
var $466f66254aa75085$var$enumerable$1 = function enumerable(rule, value, source, errors, options) {
    rule[$466f66254aa75085$var$ENUM$1] = Array.isArray(rule[$466f66254aa75085$var$ENUM$1]) ? rule[$466f66254aa75085$var$ENUM$1] : [];
    if (rule[$466f66254aa75085$var$ENUM$1].indexOf(value) === -1) errors.push($466f66254aa75085$var$format(options.messages[$466f66254aa75085$var$ENUM$1], rule.fullField, rule[$466f66254aa75085$var$ENUM$1].join(", ")));
};
var $466f66254aa75085$var$pattern$1 = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push($466f66254aa75085$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === "string") {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push($466f66254aa75085$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $466f66254aa75085$var$rules = {
    required: $466f66254aa75085$var$required$1,
    whitespace: $466f66254aa75085$var$whitespace,
    type: $466f66254aa75085$var$type$1,
    range: $466f66254aa75085$var$range,
    "enum": $466f66254aa75085$var$enumerable$1,
    pattern: $466f66254aa75085$var$pattern$1
};
var $466f66254aa75085$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, "string");
        if (!$466f66254aa75085$var$isEmptyValue(value, "string")) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) $466f66254aa75085$var$rules.whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === "") value = undefined;
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$_boolean = function _boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value)) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, "array");
        if (value !== undefined && value !== null) {
            $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
            $466f66254aa75085$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$ENUM = "enum";
var $466f66254aa75085$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $466f66254aa75085$var$rules[$466f66254aa75085$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, "string") && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value, "string")) $466f66254aa75085$var$rules.pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, "date") && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
        if (!$466f66254aa75085$var$isEmptyValue(value, "date")) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            $466f66254aa75085$var$rules.type(rule, dateObject, source, errors, options);
            if (dateObject) $466f66254aa75085$var$rules.range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $466f66254aa75085$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? "array" : typeof value;
    $466f66254aa75085$var$rules.required(rule, value, source, errors, options, type);
    callback(errors);
};
var $466f66254aa75085$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value, ruleType) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options, ruleType);
        if (!$466f66254aa75085$var$isEmptyValue(value, ruleType)) $466f66254aa75085$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($466f66254aa75085$var$isEmptyValue(value) && !rule.required) return callback();
        $466f66254aa75085$var$rules.required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $466f66254aa75085$var$validators = {
    string: $466f66254aa75085$var$string,
    method: $466f66254aa75085$var$method,
    number: $466f66254aa75085$var$number,
    "boolean": $466f66254aa75085$var$_boolean,
    regexp: $466f66254aa75085$var$regexp,
    integer: $466f66254aa75085$var$integer,
    "float": $466f66254aa75085$var$floatFn,
    array: $466f66254aa75085$var$array,
    object: $466f66254aa75085$var$object,
    "enum": $466f66254aa75085$var$enumerable,
    pattern: $466f66254aa75085$var$pattern,
    date: $466f66254aa75085$var$date,
    url: $466f66254aa75085$var$type,
    hex: $466f66254aa75085$var$type,
    email: $466f66254aa75085$var$type,
    required: $466f66254aa75085$var$required,
    any: $466f66254aa75085$var$any
};
function $466f66254aa75085$var$newMessages() {
    return {
        "default": "Validation error on field %s",
        required: "%s is required",
        "enum": "%s must be one of %s",
        whitespace: "%s cannot be empty",
        date: {
            format: "%s date %s is invalid for format %s",
            parse: "%s date could not be parsed, %s is invalid ",
            invalid: "%s date %s is invalid"
        },
        types: {
            string: "%s is not a %s",
            method: "%s is not a %s (function)",
            array: "%s is not an %s",
            object: "%s is not an %s",
            number: "%s is not a %s",
            date: "%s is not a %s",
            "boolean": "%s is not a %s",
            integer: "%s is not an %s",
            "float": "%s is not a %s",
            regexp: "%s is not a valid %s",
            email: "%s is not a valid %s",
            url: "%s is not a valid %s",
            hex: "%s is not a valid %s"
        },
        string: {
            len: "%s must be exactly %s characters",
            min: "%s must be at least %s characters",
            max: "%s cannot be longer than %s characters",
            range: "%s must be between %s and %s characters"
        },
        number: {
            len: "%s must equal %s",
            min: "%s cannot be less than %s",
            max: "%s cannot be greater than %s",
            range: "%s must be between %s and %s"
        },
        array: {
            len: "%s must be exactly %s in length",
            min: "%s cannot be less than %s in length",
            max: "%s cannot be greater than %s in length",
            range: "%s must be between %s and %s in length"
        },
        pattern: {
            mismatch: "%s value %s does not match pattern %s"
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $466f66254aa75085$var$messages = $466f66254aa75085$var$newMessages();
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $466f66254aa75085$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // ========================= Static =========================
    // ======================== Instance ========================
    function Schema(descriptor) {
        this.rules = null;
        this._messages = $466f66254aa75085$var$messages;
        this.define(descriptor);
    }
    var _proto = Schema.prototype;
    _proto.define = function define(rules) {
        var _this = this;
        if (!rules) throw new Error("Cannot configure a schema with no rules");
        if (typeof rules !== "object" || Array.isArray(rules)) throw new Error("Rules must be an object");
        this.rules = {};
        Object.keys(rules).forEach(function(name) {
            var item = rules[name];
            _this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    };
    _proto.messages = function messages(_messages) {
        if (_messages) this._messages = $466f66254aa75085$var$deepMerge($466f66254aa75085$var$newMessages(), _messages);
        return this._messages;
    };
    _proto.validate = function validate(source_, o, oc) {
        var _this2 = this;
        if (o === void 0) o = {};
        if (oc === void 0) oc = function oc() {};
        var source = source_;
        var options = o;
        var callback = oc;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            var errors = [];
            var fields = {};
            function add(e) {
                if (Array.isArray(e)) {
                    var _errors;
                    errors = (_errors = errors).concat.apply(_errors, e);
                } else errors.push(e);
            }
            for(var i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = $466f66254aa75085$var$convertFieldsError(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            var messages$1 = this.messages();
            if (messages$1 === $466f66254aa75085$var$messages) messages$1 = $466f66254aa75085$var$newMessages();
            $466f66254aa75085$var$deepMerge(messages$1, options.messages);
            options.messages = messages$1;
        } else options.messages = this.messages();
        var series = {};
        var keys = options.keys || Object.keys(this.rules);
        keys.forEach(function(z) {
            var arr = _this2.rules[z];
            var value = source[z];
            arr.forEach(function(r) {
                var rule = r;
                if (typeof rule.transform === "function") {
                    if (source === source_) source = $466f66254aa75085$var$_extends({}, source);
                    value = source[z] = rule.transform(value);
                }
                if (typeof rule === "function") rule = {
                    validator: rule
                };
                else rule = $466f66254aa75085$var$_extends({}, rule);
                 // Fill validator. Skip if nothing need to validate
                rule.validator = _this2.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = _this2.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        var errorFields = {};
        return $466f66254aa75085$var$asyncMap(series, options, function(data, doIt) {
            var rule = data.rule;
            var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return $466f66254aa75085$var$_extends({}, schema, {
                    fullField: rule.fullField + "." + key,
                    fullFields: rule.fullFields ? [].concat(rule.fullFields, [
                        key
                    ]) : [
                        key
                    ]
                });
            }
            function cb(e) {
                if (e === void 0) e = [];
                var errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) Schema.warning("async-validator:", errorList);
                if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                 // Fill error info
                var filledErrors = errorList.map($466f66254aa75085$var$complementError(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map($466f66254aa75085$var$complementError(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, $466f66254aa75085$var$format(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    var fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map(function(key) {
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = $466f66254aa75085$var$_extends({}, fieldsSchema, data.rule.fields);
                    var paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach(function(field) {
                        var fieldSchema = fieldsSchema[field];
                        var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    var schema = new Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, function(errs) {
                        var finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, filledErrors);
                        if (errs && errs.length) finalErrors.push.apply(finalErrors, errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            var res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error == null || console.error(error); // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(function() {
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(function() {
                return cb();
            }, function(e) {
                return cb(e);
            });
        }, function(results) {
            complete(results);
        }, source);
    };
    _proto.getType = function getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = "pattern";
        if (typeof rule.validator !== "function" && rule.type && !$466f66254aa75085$var$validators.hasOwnProperty(rule.type)) throw new Error($466f66254aa75085$var$format("Unknown rule type %s", rule.type));
        return rule.type || "string";
    };
    _proto.getValidationMethod = function getValidationMethod(rule) {
        if (typeof rule.validator === "function") return rule.validator;
        var keys = Object.keys(rule);
        var messageIndex = keys.indexOf("message");
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === "required") return $466f66254aa75085$var$validators.required;
        return $466f66254aa75085$var$validators[this.getType(rule)] || undefined;
    };
    return Schema;
}();
$466f66254aa75085$export$2e2bcd8739ae039.register = function register(type, validator) {
    if (typeof validator !== "function") throw new Error("Cannot register a validator by type, validator is not a function");
    $466f66254aa75085$var$validators[type] = validator;
};
$466f66254aa75085$export$2e2bcd8739ae039.warning = $466f66254aa75085$var$warning;
$466f66254aa75085$export$2e2bcd8739ae039.messages = $466f66254aa75085$var$messages;
$466f66254aa75085$export$2e2bcd8739ae039.validators = $466f66254aa75085$var$validators;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



//# sourceMappingURL=index.a0c26f5e.js.map
